import { useMemo } from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_STORE_DISTANCE } from "../../../../pages/details/queries.js";
const useStoreDistance = () => {
  const [getStoreDistance, { error, loading, data }] = useLazyQuery(GET_STORE_DISTANCE);
  const { distance, timeByCar, timeByFoot } = data?.store || {};
  return useMemo(
    () => [
      getStoreDistance,
      {
        // set a clean attributes list if data is defined and undefined if data is undefined
        data: data ? { distance, timeByCar, timeByFoot } : data,
        loading,
        error
      }
    ],
    [data, distance, timeByCar, timeByFoot, loading, error, getStoreDistance]
  );
};
export {
  useStoreDistance as default
};
//# sourceMappingURL=use-store-distance.js.map
